export default "__VITE_ASSET__CAG3dxUd__"